"use client";

import { usePathname } from "next/navigation";
import { m, useScroll, useSpring } from "motion/react";
import { useCoarseOrNarrow } from "@/hooks/use-coarse-or-narrow";
import { isBlogPath } from "@/lib/blog/is-blog-path";

function ScrollProgressBar() {
  const { scrollYProgress } = useScroll();
  const scaleX = useSpring(scrollYProgress, {
    stiffness: 100,
    damping: 30,
    restDelta: 0.001,
  });

  return (
    <m.div
      aria-hidden
      className="fixed top-0 left-0 right-0 h-[2px] z-[200] origin-left"
      style={{
        scaleX,
        background:
          "linear-gradient(to right, var(--color-blue), rgba(59, 130, 246, 0.4))",
      }}
    />
  );
}

/**
 * Top-of-page scroll progress bar — Framer Motion useScroll smoothed with
 * useSpring. Aceternity / Linear-style detail that signals quality.
 *
 * Desktop only: on coarse-pointer / narrow viewports we render null, so the
 * whole-page useScroll + useSpring integrator (the single largest motion/react
 * per-scroll-frame cost on mobile — it never idles on a 24,000px page) is never
 * mounted. Mount-split (not an early-return) keeps the spring hooks
 * unconditional. The bar is a 2px fixed overlay, so null causes no layout shift.
 */
export function ScrollProgress() {
  const lite = useCoarseOrNarrow();
  const pathname = usePathname();
  // Founder ban (blog spec, decision #2): nothing scroll-driven may render
  // on blog surfaces — the bar never mounts there.
  return lite || isBlogPath(pathname) ? null : <ScrollProgressBar />;
}
